import { useEffect, useState } from 'react';
import { _single } from '../../../core/services/dataBean/EntityCatalog';
import { ComponentSpinner } from './ComponentSpinner/ComponentSpinner';
import { spinnerStore } from '../../../core/Stores/SpinnerStore/SpinnerStore';

interface Props {
    value?: string;
    icon: string;
    eventClick: any;
    clase?: string;
    children?: any;
    disable?: boolean;
    useMargin?: boolean;
    spinner?: boolean;
    timeStopClickSeg?: number;
}

export const BasicButton = ({ value, icon, eventClick, clase, children, disable, useMargin, spinner, timeStopClickSeg }: Props) => {
    const margin = useMargin ? 'mbtn' : '';
    const [spin, setSpin] = useState(_single.getStateSpinner());
    const [isBlocked, setIsBlocked] = useState(false);

  useEffect(() => {
    const unsubscribe = spinnerStore.subscribe((isActive, activeCount) => {
      setSpin(isActive);
    //   console.log(activeCount)
    });
    return () => unsubscribe();
  }, []);

    const clickButton = () => {
        if (isBlocked) return;
        setIsBlocked(true);
        try {
            eventClick();
        } finally {
            setTimeout(() => setIsBlocked(false), timeStopClickSeg ?? 2 * 1000);
        }
    };

    const isDisabled = disable || spin || isBlocked;

    return (
        <div className={margin}>
            {spinner ? (
                spin ? (
                    <ComponentSpinner />
                ) : (
                    <button
                        type="button"
                        className={clase ? `btn btn-${clase} ml-2` : 'btn btn-primary ml-2'}
                        onClick={clickButton}
                        disabled={isDisabled}
                    >
                        <i className={`${icon} label-icon align-middle`}></i> {value}{children}
                    </button>
                )
            ) : (
                <button
                    type="button"
                    className={clase ? `btn btn-${clase} ml-2` : 'btn btn-primary ml-2'}
                    onClick={clickButton}
                    disabled={isDisabled}
                >
                    <i className={`${icon} label-icon align-middle`}></i> {value}{children}
                </button>
            )}
        </div>
    );
};
